import { fromJS } from 'immutable';
import { filtersById, playbookContent, shareUrl, clearShareUrl } from './types';

export const playbookContentReducersObject = {
  [playbookContent.request]: (state) =>
    state.withMutations((currentState) =>
      currentState.setIn(['playbook', 'network', 'loading'], true),
    ),
  [playbookContent.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['playbook'], fromJS(action.response))
        .setIn(['playbook', 'network', 'loading'], false)
        .setIn(['playbook', 'network', 'error'], false),
    ),
  [playbookContent.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['playbook', 'network', 'loading'], false)
        .setIn(['playbook', 'network', 'error'], action.error),
    ),
  [filtersById.request]: (state) =>
    state.withMutations((currentState) =>
      currentState.setIn(['playbookFilters', 'network', 'loading'], true),
    ),
  [filtersById.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['playbookFilters'], fromJS(action.response))
        .setIn(['playbookFilters', 'network', 'loading'], false)
        .setIn(['playbookFilters', 'network', 'error'], false),
    ),
  [filtersById.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['playbookFilters', 'network', 'loading'], false)
        .setIn(['playbookFilters', 'network', 'error'], action.error),
    ),
  [clearShareUrl]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['shareUrl', 'url'], undefined)
        .setIn(['shareUrl', 'network', 'loading'], false)
        .setIn(['shareUrl', 'network', 'error'], false),
    ),
  [shareUrl.request]: (state) =>
    state.withMutations((currentState) =>
      currentState.setIn(['shareUrl', 'network', 'loading'], true),
    ),
  [shareUrl.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['shareUrl', 'url'], fromJS(action.response.url))
        .setIn(['shareUrl', 'network', 'loading'], false)
        .setIn(['shareUrl', 'network', 'error'], false),
    ),
  [shareUrl.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['shareUrl', 'network', 'loading'], false)
        .setIn(['shareUrl', 'network', 'error'], action.error),
    ),
};

export default playbookContentReducersObject;
